// @ts-nocheck
export const processDocumentIfNeeded = async (
    selectedImage,
    imageData,
    token,
    threadId,
    threadDispatch,
    ThreadService
  ) => {
    if (!selectedImage || !imageData) return;
    
    const isDocument =
      selectedImage.type === "application/pdf" ||
      selectedImage.type === "text/csv";
    
    if (!isDocument) return;
  
    try {
      const parseResponse = await fetch(
        `${process.env.REACT_APP_API_URL}/parse-document`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            fileData: imageData,
            fileType: selectedImage?.type,
          }),
        }
      );
  
      if (parseResponse.ok) {
        const data = await parseResponse.json();
        const parsedContent = data.parsedContent;
  
        threadDispatch({
          type: "SET_THREAD_DOCUMENT_CONTEXT",
          payload: {
            threadId,
            documentContext: parsedContent,
            documentName: selectedImage?.name,
          },
        });
  
        await ThreadService.updateThreadDocumentContext(
          threadId,
          parsedContent,
          selectedImage?.name
        );
      }
    } catch (error) {
      console.error("Error parsing document:", error);
    }
  };